// ErrorPage.js 예시
import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h1>404 - 페이지를 찾을 수 없습니다.</h1>
      <p>요청하신 페이지가 존재하지 않습니다.</p>
    </div>
  );
};

export default ErrorPage;
